// Stub auth middleware for client-side shim.
export const attachSupabaseAuth = { handler: (fn: any) => fn };
export const requireSupabaseAuth = { handler: (fn: any) => fn };
